import React, { useState } from "react";
import Modal from "./Modal";
import Spinner from "./Spinner";

export default function Confirm({ open, title, message, danger, confirmText = "Confirmar", cancelText = "Cancelar", onClose, onConfirm }) {
  const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    try { await onConfirm(); } finally { setBusy(false); }
  }
  return (
    <Modal
      open={open}
      title={title}
      onClose={busy ? undefined : onClose}
      footer={
        <>
          <button className="secondary" disabled={busy} onClick={onClose}>{cancelText}</button>
          <button className={danger ? "danger" : ""} disabled={busy} onClick={go}>
            {busy && <Spinner />} {confirmText}
          </button>
        </>
      }
    >
      <p style={{ margin: 0, color: "var(--text-body)" }}>{message}</p>
    </Modal>
  );
}
